import {
  Button,
  DialogContent,
  FormHelperText,
  Grid,
  IconButton,
  InputLabel,
  List,
  ListItem,
  Typography
} from '@material-ui/core'

import moment from 'moment'
import { useSnackbar } from 'notistack'
import { useRef, useState } from 'react'

import DialogAster from 'asterX-UIkit/Dialog/DialogAster'
import DialogTitleCustom from 'asterX-UIkit/Dialog/DialogTitleCustom'
import { TrashIcon, UploadIcon } from 'asterX-UIkit/Icons'
import { FileIcon } from 'asterX-UIkit/Icons/FileIcon'
import AsterTextField from 'asterX-UIkit/Inputs/AsterTextField'

import * as status from 'constants/statuses'
import { useAuthStore } from 'context/AuthStore'
import { useHomeStore } from 'context/HomeStore'
import { useResErrors } from 'hooks'
import { MiscService } from 'lib/api'
import { bytesToMB } from 'lib/utils'
import NotificationModal from './NotificationModal/NotificationModal'
import { validateForm } from './conts'
import { useCreateStyles } from './create.styles'

const CreateModal = ({ open, prevForm, onClose }) => {
  const classes = useCreateStyles()
  const { standardCheck } = useResErrors()
  const { enqueueSnackbar } = useSnackbar()
  const modalRef = useRef(null)
  const inputFileId = Math.random().toString()

  const [errors, setErrors] = useState({})
  const [openModal, setOpenModal] = useState(false)
  const [errorModal, setErrorModal] = useState(false)

  const {
    authStore: { user }
  } = useAuthStore()

  const {
    homeStore: { form, loading },
    homeStoreFunc: { onResetForm, handleChangeForm, handleUpload, handleDelete }
  } = useHomeStore()

  const handleClose = () => {
    onClose()
    onResetForm()
    setErrors({})
  }

  const handleSave = async form => {
    const errorForms = validateForm(form, prevForm)
    const hasErrors = Object.values(errorForms).some(error => error !== '')

    setErrors(errorForms)

    if (hasErrors) return

    const userPhotos = form?.userPhotos?.map(item => item?.fileDownloadUri)

    const data = {
      ...form,
      branchCode: user.data?.branch?.code,
      createdBy: user.data?.username,
      createdByFullname: user.data?.lastName + ' ' + user.data?.firstName,
      createdDate: moment().format(),
      department: prevForm.division,
      module: form.module ? form.module : prevForm.module,
      position: user.data?.position,
      subdivision: user.data?.subdivision,
      status: status.NEW_STATUS,
      userPhotos
    }

    await MiscService.createSupport(data).then(response =>
      standardCheck(
        response,
        () => {
          enqueueSnackbar('Отправлено', {
            variant: 'success'
          })
          handleClose()
        },
        {
          onFail: () => {
            setErrorModal(true)
            handleClose()
          }
        }
      )
    )
  }

  return (
    <DialogAster id="modal" onClose={handleClose} open={open}>
      <DialogTitleCustom onClose={handleClose}>
        Создать заявку - {prevForm.module}
      </DialogTitleCustom>

      <DialogContent ref={modalRef}>
        <Grid
          container
          direction={'row'}
          alignItems={'center'}
          justifyContent={'center'}
          spacing={4}
        >
          <Grid item container xs={12} md={12} className={classes.relative}>
            <AsterTextField
              fullWidth
              label="Корпоративная почта"
              name="email"
              value={form.email}
              onChange={handleChangeForm}
            />

            {!!errors.email && (
              <FormHelperText className={classes.errorText}>
                {errors.email}
              </FormHelperText>
            )}
          </Grid>

          <Grid item container xs={12} md={12} className={classes.relative}>
            <AsterTextField
              fullWidth
              label="Тема"
              name="subject"
              value={form.subject}
              onChange={handleChangeForm}
            />

            {!!errors.subject && (
              <FormHelperText className={classes.errorText}>
                {errors.subject}
              </FormHelperText>
            )}
          </Grid>

          <Grid
            item
            xs={12}
            md={12}
            className={classes.relative}
            style={{ marginBottom: 5 }}
          >
            <InputLabel shrink style={{ marginBottom: 3 }}>
              {'Описание проблемы/ошибки'}
            </InputLabel>

            <AsterTextField
              label="Подробно опишите проблему с которой столкнулись"
              fullWidth
              multiline
              rows={5}
              name="description"
              value={form.description}
              onChange={handleChangeForm}
            />

            {!!errors.description && (
              <FormHelperText className={classes.errorText}>
                {errors.description}
              </FormHelperText>
            )}
          </Grid>

          <Grid item xs={12} md={12}>
            <input
              accept="/*"
              style={{ display: 'none' }}
              id={inputFileId}
              multiple
              type="file"
              onChange={handleUpload}
            />
            <label htmlFor={inputFileId}>
              <Grid item className={classes.uploader}>
                <Grid item className={classes.icon}>
                  <UploadIcon />
                </Grid>
                <Grid item>
                  <Typography className={classes.uplTitle}>
                    <span>Нажмите, чтобы загрузить</span> или перетащите
                  </Typography>
                  <Typography className={classes.uplSubtitle}>
                    Размер файла не может превышать 10мб
                  </Typography>
                </Grid>
              </Grid>
            </label>

            {(form?.userPhotos || []).map((file, idx) => (
              <List className={classes.list} key={`userPhotos_${idx}`}>
                <ListItem className={classes.listItem}>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'flex-start',
                      width: '10%'
                    }}
                  >
                    <FileIcon />
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      width: '80%',
                      flexDirection: 'column'
                    }}
                  >
                    <Typography style={{ overflowWrap: 'break-word' }}>
                      {file?.originalFileName}
                    </Typography>
                    <Typography>{bytesToMB(file?.size)}</Typography>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'flex-start',
                      width: '10%',
                      height: '100%'
                    }}
                  >
                    <IconButton
                      onClick={() => handleDelete(file?.fileDownloadUri)}
                    >
                      <TrashIcon />
                    </IconButton>
                  </div>
                </ListItem>
              </List>
            ))}
          </Grid>

          <Grid item xs={6} md={6}>
            <Button
              fullWidth
              variant="outlined"
              color={'default'}
              disabled={loading}
              onClick={handleClose}
            >
              Отмена
            </Button>
          </Grid>

          <Grid item xs={6} md={6}>
            <Button
              fullWidth
              variant="contained"
              color={'primary'}
              disabled={loading}
              onClick={() => handleSave(form)}
            >
              Отправить
            </Button>
          </Grid>
        </Grid>

        <NotificationModal
          fullWidth
          error={errorModal}
          open={openModal}
          onClose={() => setOpenModal(prev => !prev)}
        />
      </DialogContent>
    </DialogAster>
  )
}

export default CreateModal
